import { createPromiseAction } from '@adobe/redux-saga-promise';
/**
 * 법인번호 기업 조회
 */
// 법인번호 기업 조회
export const fetchGetExternalOrganizationsAction = createPromiseAction(
  'FETCH_GET_EXTERNAL_ORGANIZATIONS'
);
